(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../core/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../core/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert);
    global.and = mod.exports;
  }
})(this, function (exports, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.and = undefined;
  /**
   * Applies <code>&&</code> between the former value and <code>args</code>
   * @function
   * @memberof lang
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...*} [args] Other operands.
   * @return {Object} Returns the updated object.
   * @example and({ nested: { prop: true } }, 'nested.prop', true) // { nested: { prop: true } }
   * @example and({ nested: { prop: true } }, 'nested.prop', true, false) // { nested: { prop: false } }
   * @since 1.0.0
   */

  var and = (0, _convert.convert)(function (v) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return args.reduce(function (acc, arg) {
      return acc && arg;
    }, v);
  });
  exports.and = and;
});